import React from 'react';
import NLLView from './NLLView';

const NLLPage: React.FC = () => {
  return <NLLView />;
};

export default NLLPage;
